export default __webpack_public_path__ + "static/media/bootcamp-login-logo.1919d91915cf01e2c16725e2b7bb72cb.svg";